import * as THREE from "three";

export function createScene(backgroundColor) {
  const scene = new THREE.Scene();
  scene.background = new THREE.Color(backgroundColor);
  return scene;
}
